import React from 'react';
import PropTypes from 'prop-types';
import TextInput from 'src/ui/library/TextInput';

class TextArea extends React.Component {
  static propTypes = {
    styleType: PropTypes.string,
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    rows: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    style: PropTypes.object,
    inputProps: PropTypes.object,
  };

  getStyles = (type, height, width, style) => {
    switch (type) {
      default:
        return {
          textField: {
            height: height ? height : '100%',
            maxWidth: width ? width : '100%',
            border: '1px solid transparent',
            ...(style || {}),
          },
        };
    }
  };

  render() {
    const { styleType, height, width, rows, style, inputProps, ...otherProps } = this.props;
    const styles = this.getStyles(styleType, height, width, style);
    const textAreaInputProps = {
      ...(inputProps || {}),
      style: {
        ...((inputProps && inputProps.style) || {}),
        ...(style && style.textAlign ? { textAlign: style.textAlign } : {}),
      },
    };

    return <TextInput multiline rows={rows ? rows : '4'} useEllipsisLabel={true} styles={styles} inputProps={textAreaInputProps} {...otherProps} />;
  }
}

export default TextArea;
